import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { soundSystem } from '../utils/soundSystem';

const SoundToggle: React.FC = () => {
  const [muted, setMuted] = useState(() => soundSystem.isMuted());

  useEffect(() => {
    soundSystem.init();
    setMuted(soundSystem.isMuted());
  }, []);

  const toggle = () => {
    const nowMuted = soundSystem.toggleMute();
    setMuted(nowMuted);
    if (!nowMuted) soundSystem.playClick();
  };

  return (
    <motion.button
      onClick={toggle}
      title={muted ? 'Activer les sons' : 'Désactiver les sons'}
      aria-label={muted ? 'Activer les sons' : 'Désactiver les sons'}
      className="sound-toggle"
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.92 }}
      style={{
        position: 'fixed',
        bottom: '1.25rem',
        right: '1.25rem',
        zIndex: 9000,
        width: '2.25rem',
        height: '2.25rem',
        borderRadius: '50%',
        border: '1px solid rgba(255,255,255,0.1)',
        background: 'rgba(10, 10, 15, 0.85)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        color: muted ? '#525252' : '#e53935',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'color 0.2s ease, border-color 0.2s ease',
        boxShadow: muted ? 'none' : '0 0 12px rgba(229, 57, 53, 0.25)',
      }}
    >
      {muted ? (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
          <line x1="23" y1="9" x2="17" y2="15" />
          <line x1="17" y1="9" x2="23" y2="15" />
        </svg>
      ) : (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
          <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
          <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
        </svg>
      )}
    </motion.button>
  );
};

export default SoundToggle;
